import { render } from "./MediaPressList.vue?vue&type=template&id=0637429d&scoped=true"
import script from "./MediaPressList.vue?vue&type=script&lang=js"
export * from "./MediaPressList.vue?vue&type=script&lang=js"

import "./MediaPressList.vue?vue&type=style&index=0&id=0637429d&scoped=true&lang=scss"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0637429d"]])

export default __exports__